export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
      <title>About | Be-Apuo Media Intelligence</title>
      <div className="label-caps text-heritage">About</div>
      <h1 className="mt-2 font-editorial font-black text-4xl sm:text-5xl tracking-tight text-ink">
        Evidence first. Always.
      </h1>
      <div className="prose-editorial mt-8 text-ink border-t-2 border-heritage pt-8">
        <p>
          Be-Apuo Media is a New York–based intelligence and journalism platform covering the
          United States, Ghana, Africa, the African diaspora, and the wider world—connecting
          local experience, diaspora identity, and global opportunity.
        </p>
        <p>
          We produce independent research, fact-checking, analysis, civic education, and
          evidence-based journalism. Every story moves through a disciplined editorial process
          involving research, sources, claims, verification, content creation, editorial review,
          and publication. When we get something wrong, we correct it openly and preserve the record.
        </p>
        <h2>Our workflow</h2>
        <p>
          Research → Sources → Claims → Verification → Content → Editorial Review → Publication.
          Nothing reaches this public site until it has been reviewed and approved inside our
          Intelligence Command Center.
        </p>
      </div>
    </div>
  );
}
